export default () => ({
  profile: {},
  version: {},
  featureFlags: []
})
